import i18n from '@/lang/i18n';
export * from '@/services/consts/cvr_upload';
export * from '@/services/consts/operation_office';
export * from '@/services/consts/job_status';
export * from '@/services/consts/vehicle';
export * from '@/services/consts/device';
export * from '@/services/consts/audit_logs';

export const AUTHORITY_CACHE_RETRY_COUNT = 10
export const AUTHORITY_CACHE_RETRY_INTERVAL = 100
export const DELIVERY_PLAN_RULE_2024_START_DATE_TIME = '2024-04-01 00:00:00';

export const WORK_TYPES = [
  "leaving_warehouse",
  "loading",
  "unloading",
  "shipping",
  "incidental_work",
  "refueling",
  "wait",
  "break",
  "rest",
  "returning_warehouse",
];

export const WORK_EVENT_TYPES = {
  leaving_warehouse: "出庫",
  loading: "荷積",
  unloading: "荷卸",
  shipping: "荷待",
  incidental_work: "付帯作業",
  refueling: "給油",
  wait: "待機",
  break: "休憩",
  rest: "休息",
  returning_warehouse: "帰庫",
  stopping: "停車",
};

export const SELECT_WORK_EVENT_TYPES = {
  loading: "荷積",
  unloading: "荷卸",
  shipping: "荷待",
  incidental_work: "付帯作業",
  refueling: "給油",
  wait: "待機",
  break: "休憩",
  rest: "休息",
};

interface routingAuthority {
  [key: string]: string;
}

export const routingAuthorityNames = {
  Dashboard: "octlink.dashborad.read",
  DailyReport: "octlink.daily_report.read",
  DailyReportEdit: "octlink.daily_report.update",
  DailyReportLayout: "octlink.daily_report_layout.read",
  Spot: "octlink.spot.read",
  SafeDrivingSetting: "octlink.driving_score.read",
  DailyReportHistory: "octlink.daily_report.read",
  MonthlyReport: "octlink.monthly_report.read",
  SafeDrivingReport: "octlink.safe_driving_report.read",
  OperationOffice: "octlink.operation_office.read",
  InstallationOffice: "octlink.installation_office.read",
  InstallationOfficeForm: "octlink.installation_office.form",
  Vehicle: "octlink.vehicle.read",
  VehicleForm: "octlink.vehicle.read",
  Accounts: "octlink.user.read",
  Firmwares: "octlink.firmware.read",
  FirmwareDevices: "octlink.firmware.read",
  FirmwareBulkUpdateList: "octlink.firmware.read",
  FirmwareBulkUpdateForm: "octlink.firmware.update",
  AccountForm: "octlink.user.read",
  Authority: "octlink.user_role.read",
  Every24hoursReport: "octlink.every_24hours_delivery_report.read",
  TrackingService: "octlink.fleet_tracking_service.read",
  OperationOfficeEditForm: "octlink.operation_office.update",
  OperationOfficeCreateForm: "octlink.operation_office.create",
  DownloadData: "octlink.download_data.output",
  DownloadDataHistories: "octlink.download_data.read",
  CsvDataExport: "octlink.csv_data_export.read",
  Groups: "octlink.group.read",
  GroupForm: "octlink.group.read",
  CvrConvert: "octlink.cvr_upload.read",
  Temperature: "octlink.temperature.read",
  Device: "octlink.device.read",
  AllowAccessOffice: "octlink.allow_access_office.read",
  DataLinkage: 'octlink.data_linkage.read',
  SubManagementOffice: 'octlink.submanagement_office.read',
  SubManagementOfficeForm: 'octlink.submanagement_office.form',
  roleAssignment: 'octlink.role_attach.update',
  Departments: 'octlink.department.read',
  UserRoles: 'octlink.user_role.read',
  TenkoAssociation: 'octlink.it_tenko.read',
  AuditLog: 'octlink.audit_log.read',
  GpsTrackerSetting: 'octlink.gps_tracker_settings.read',
  GpsTrackerDailyReport: 'octlink.gps_tracker_daily_report.read',
} as routingAuthority;

interface permissionDisplayNameType {
  [key: string]: string;
}
export const permissionDisplayName = {
  summary: "ダッシュボード",
  firmware: "ファームウェア",
  daily_report: "日報",
  daily_report_layout: "日報プリセット",
  every_24hours_delivery_report: "24時間毎データ",
  monthly_report: "月報",
  temperature: "温度管理",
  safe_driving_report: "安全運転帳票",
  cvr_upload: "ドラレコ映像取得",
  user: "アカウント",
  role_attach: "権限付与",
  user_role: "権限管理",
  it_tenko: "IT点呼データ連携",
  vehicle: "車両設定",
  device: "デバイス管理",
  submanagement_office: "準管理会社",
  operation_office: "運営会社",
  spot: "地点登録",
  driving_score: "運転スコア",
  group: "グループ",
  installation_office: "設置会社",
  allow_access_office: "運営会社参照許可",
  department: "組織",
  download_data: "他社連携用CSV出力",
  csv_data_export: "CSV出力",
  data_linkage: "データ連携",
  audit_log: "操作ログ",
  gps_tracker_settings: "GPS Tracker設定",
  gps_tracker_daily_report: "GPS Tracker日報",
  fleet_tracking_service: "動態管理サービス",
} as permissionDisplayNameType;

export const DOWNLOAD_DATA_FORMATS = [
  {
    title: "ロジ勤怠",
    value: "logi_attendance",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\LogiAttendanceCsvCreateService",
  },
  {
    title: "配達くん",
    value: "haitatsu",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\HaitatsuCsvCreateService",
  },
  {
    title: "TUMIX",
    value: "tumix",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\TumixCsvCreateService",
  },
  {
    title: "TUMIX日報",
    value: "tumix_daily_report",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\TumixDailyReportCsvCreateService",
  },
  {
    title: "TUMIX配送明細",
    value: "tumix_shipping_detail",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\TumixShippingDetailCsvCreateService",
  },
  {
    title: "LOGIX",
    value: "logix",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\LogixCsvCreateService",
  },
  {
    title: "LOGIX日報",
    value: "logix_daily_report",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\LogixDailyReportCsvCreateService",
  },
  {
    title: "LOGIXイベント",
    value: "logix_event",
    file_type: "csv",
    request_type:
      "App\\Services\\OutputReports\\DownloadData\\LogixEventCsvCreateService",
  },
];

export const CSV_DATA_EXPORT_FORMATS = [
  {
    title: "ETC明細",
    value: "etc_detail",
    file_type: "csv",
    request_type: "App\\Services\\OutputReports\\DownloadData\\EtcDetailCsvCreateService",
  },
  {
    title: "給油明細",
    value: "refueling_detail",
    file_type: "csv",
    request_type: "App\\Services\\OutputReports\\DownloadData\\RefuelingDetailCsvCreateService",
  },
];

export const DOWNLOAD_DATA_REMOVED_FORMATS = [
  'tumix_daily_report',
  'tumix_shipping_detail',
  'logix_daily_report',
  'logix_event',
]

export const ITTENKO_V2 = "ittenko";
export const ITTENKO_V3 = "ittenko_v3";
export const WHITE_SAFETY = "white_safety";

export const tenkoTypes = [
  { title: i18n.global.t('pages.operationOffices.form.ittenko.tenkoType.ittenko'), value: ITTENKO_V2 },
  { title: i18n.global.t('pages.operationOffices.form.ittenko.tenkoType.ittenkoV3'), value: ITTENKO_V3 },
  { title: i18n.global.t('pages.operationOffices.form.ittenko.tenkoType.whiteSafety'), value: WHITE_SAFETY },
];

export enum sortType {
  ASK = "asc",
  DESC = "desc",
}

export enum accountType {
  managementOffice = "ManagementOffice",
  subManagementOffice = "SubManagementOffice",
  installationOffice = "InstallationOffice",
  operationOffice = "OperationOffice",
}

export enum vehiclePositionSourceType {
  INITIAL = "initial",
  SUBSCRIBED = "subscribed"
}

export const safeCenterCoordinates = { lat: 36.204824, lng: 138.252924 }

export const PAGE_STRUCTURES_BY_DAY = 'day';
export const PAGE_STRUCTURES_BY_OPERATION = 'operation';
export const PAGE_STRUCTURES_BY_DRIVER = 'by_driver';
export const DAILY_REPORT_PAGE_STRUCTURES = [
  PAGE_STRUCTURES_BY_DAY,
  null,
  PAGE_STRUCTURES_BY_OPERATION,
  null,
  PAGE_STRUCTURES_BY_DRIVER,
];
export const DAILY_REPORT_PAGE_UNITS = [
  { key: PAGE_STRUCTURES_BY_DAY, label: i18n.global.t('pages.dailyReports.outputLayout.pageUnit.byDay'), data: 0 },
  { key: PAGE_STRUCTURES_BY_OPERATION, label: i18n.global.t('pages.dailyReports.outputLayout.pageUnit.byDeliveryPlan'), data: 2 },
  { key: PAGE_STRUCTURES_BY_DRIVER, label: i18n.global.t('pages.dailyReports.outputLayout.pageUnit.byDriver'), data: 4 },
];

export const dailyReportChartDisplay = [
  { key: "speed", label: "速度", data: "" },
  { key: "high_speed", label: "高速", data: "" },
  { key: "actual_vehicle", label: "実車", data: "" },
  { key: "stop", label: "停止", data: "" },
  { key: "loading", label: "荷積", data: "" },
  { key: "unloading", label: "荷卸", data: "" },
  { key: "shipping", label: "荷待", data: "" },
  { key: "incidental_work", label: "付帯作業", data: "" },
  { key: "refueling", label: "給油", data: "" },
  { key: "wait", label: "待機", data: "" },
  { key: "break", label: "休憩", data: "" },
  { key: "rest", label: "休息", data: "" },
  { key: "long_time_continuous_operation", label: "長時間連続運転", data: "" },
  { key: "over_speed", label: "速度超過", data: "" },
  { key: "rapid_acceleration", label: "急加速", data: "" },
  { key: "rapid_deceleration", label: "急減速", data: "" },
  {
    key: "sharp_steering_wheel_and_steep_turn",
    label: "急ﾊﾝﾄﾞﾙ・急旋回 ",
    data: "",
  },
  { key: "excess_rotation", label: "回転数超過 ", data: "" },
  { key: "idling", label: "アイドリング", data: "" },
  { key: "rotational_speed", label: "回転数", data: "" },
  { key: "temperature_sensor", label: "温度管理", data: "" },
];


export const DRIVER_ROLE_TYPE = 2;
export const ADMIN_ROLE_TYPE = 1;

export const GENERATE_ACCOUNT_PASSWORD_PREFIX = "Map@";

export const GENERATE_EMAIL_DOMAIN = ".y.octlink.jp";

export const SENSOR_SETTINGS_MAX_SCALE = 135;
export const SENSOR_SETTINGS_MIN_SCALE = -30;
export const SENSOR_CHART_STEP_SCALE = 5;
export const SENSOR_CHART_STEP_SCALE_CHANGE_THRESHOLD = 50;
export const SENSOR_SETTINGS_SELECTABLE_LIST_LENGTH = ((SENSOR_SETTINGS_MAX_SCALE - SENSOR_SETTINGS_MIN_SCALE) / SENSOR_CHART_STEP_SCALE) + 1;
export const SENSOR_SETTINGS_SELECTABLE_LIST = Array(SENSOR_SETTINGS_SELECTABLE_LIST_LENGTH).fill(SENSOR_SETTINGS_MAX_SCALE).map((v, i) => (v - i * SENSOR_CHART_STEP_SCALE));

export const OUTPUT_PDF_TYPE_TEMPERATURE_GRAPH = "App\\Services\\OutputReports\\Sensors\\PdfCreateService";
export const OUTPUT_PDF_TYPE_TEMPERATURE_LIST = "App\\Services\\OutputReports\\Sensors\\PdfCreateListService";
export const SUB_MANAGEMENT_OFFICE_CSV_IMPORT_TYPE = "App\\Services\\Csv\\Imports\\SubManagementOfficeService"
export const SUB_MANAGEMENT_OFFICE_ICE_EXPORT_TYPE = "App\\Services\\Csv\\Exports\\SubManagementOfficeService"

export const CAMERA_ON_KEY = "camera_on";

export const UNEXPECTED_EVENT_KEY = "unexpectedEvent";
export const SPECIAL_EXTENSION_KEY = "specialExtension";

export const MANAGEMENT_OFFICE_TYPE = 'App\\Models\\ManagementOffice';
export const SUB_MANAGEMENT_OFFICE_TYPE = 'App\\Models\\SubManagementOffice'
export const INSTALLATION_OFFICE_TYPE = 'App\\Models\\InstallationOffice'
export const OPERATION_OFFICE_TYPE = 'App\\Models\\OperationOffice';
export const DEPARTMENT_OFFICE_TYPE = 'App\\Models\\Department';

export const FIRST_LEVEL_DEPARTMENT_KEY = 1
export const SECOND_LEVEL_DEPARTMENT_KEY = 2

export const DEPARTMENT_SELECTABLE_LEVEL = [
  { key: FIRST_LEVEL_DEPARTMENT_KEY, label: i18n.global.t('pages.departments.createOrUpdateModal.firstLevel') },
  { key: SECOND_LEVEL_DEPARTMENT_KEY, label: i18n.global.t('pages.departments.createOrUpdateModal.secondLevel')},
];

export const DEVICE_FIRMWARE_DEFAULT_DAYS_RANGE = 7

export const EVENT_TYPE_RAPID_DECELERATION = 1;
export const EVENT_TYPE_RAPID_ACCELERATION = 2;
export const EVENT_TYPE_SUDDEN_HANDLE = 3;
export const EVENT_TYPE_SHARP_TURN = 4;
export const EVENT_TYPE_OVERSPEED = 5;

export const DRIVING_ALERT_EVENT_TYPES = [
  EVENT_TYPE_RAPID_DECELERATION,
  EVENT_TYPE_RAPID_ACCELERATION,
  EVENT_TYPE_SUDDEN_HANDLE,
  EVENT_TYPE_SHARP_TURN,
  EVENT_TYPE_OVERSPEED
];

export const MANUAL_LINK = {
  Dashboard: "https://cdn.smart-trucking.services/manual/manual_dashboard_octlink.pdf",
  DailyReport: "https://cdn.smart-trucking.services/manual/daily-report_octlink.pdf",
  DailyReportLayout: "https://cdn.smart-trucking.services/manual/layout_octlink.pdf",
  Every24hoursReport: "https://cdn.smart-trucking.services/manual/24data_octlink.pdf",
  MonthlyReport: "https://cdn.smart-trucking.services/manual/monthly-report_octlink.pdf",
  SafeDrivingReport: "https://cdn.smart-trucking.services/manual/safe-driving-report_octlink.pdf",
  Accounts: "https://cdn.smart-trucking.services/manual/accounts_octlink.pdf",
  Vehicle: "https://cdn.smart-trucking.services/manual/vehicles_octlink.pdf",
  OperationOfficeEditForm: "https://cdn.smart-trucking.services/manual/operation-office_octlink.pdf",
  Spot: "https://cdn.smart-trucking.services/manual/spots_octlink.pdf",
  SafeDrivingSetting: "https://cdn.smart-trucking.services/manual/score-report_octlink.pdf",
  Groups: "https://cdn.smart-trucking.services/manual/groups_octlink.pdf",
  DownloadData: "https://cdn.smart-trucking.services/manual/dataoutput_octlink.pdf",
  CvrConvert: "https://cdn.smart-trucking.services/manual/cvrvideo_octlink.pdf",
  Firmwares: "https://cdn.smart-trucking.services/manual/lists-of-firmware_octlink.pdf",
  FirmwareDevices: "https://cdn.smart-trucking.services/manual/firmware-settings_octlink.pdf",
  InstallationOffice: "https://cdn.smart-trucking.services/manual/Installation_octlink.pdf",
  DeviceList: "https://cdn.smart-trucking.services/manual/device_octlink.pdf",
  AllowAccessOffice: "https://cdn.smart-trucking.services/manual/reference%20permission%20setting_octlink.pdf",
  Departments: "https://cdn.smart-trucking.services/manual/organization_octlink.pdf",
  UserRoles: "https://cdn.smart-trucking.services/manual/authority%20management_octlink.pdf",
  RoleAssaignment: "https://cdn.smart-trucking.services/manual/empowerment_octlink.pdf"
}

export const MONTHLY_REPORT_STATUS_ITEMS = [
  { key: 'total', field: 'total' },
  { key: 'inQueue', field: 'in_queue' },
  { key: 'inProgress', field: 'in_progress' },
  { key: 'skipped', field: 'skipped' },
  { key: 'succeeded', field: 'succeeded' },
  { key: 'failed', field: 'failed' }
];

export const DISPLAY_REPORT_LAYOUTS = [
  { key: "work_detail", label: i18n.global.t('pages.dailyReportLayout.modal.label.reportLayout.workDetails') },
  { key: "etc_detail", label: i18n.global.t('pages.dailyReportLayout.modal.label.reportLayout.etcDetails') }
];

export const MAX_SELECTABLE_PREVIOUS_MONTH = 13;
